/**
 * @param {{ default_full_slug?: string | null | undefined, content: {component?: string }}} storyData
 * @param {string} localeString
 */
export const getStoryUrl = (storyData, localeString) => {
  switch (storyData.content.component) {
    case "productIngredients":
    case "productCategory":
    case "product":
    case "productEdition": {
      const match = storyData.default_full_slug?.match(
        /energydrink\/products\/?(.*)/i,
      );
      if (!match) {
        throw new Error(`Unexpected path: ${storyData.default_full_slug}`);
      }

      return `/${localeString}/energydrink/products/${match[1]}`;
    }
    case "productIndex": {
      return `/${localeString}/energydrink/products`;
    }
    case "companyOldIndex":
    case "companyHistoryOldPage":
    case "flyingChocolatePage":
    case "contactPage":
    case "infoPage":
    case "page":
    case "speakUpPage":
    case "sustainabilityPage2025":
    case "sustainabilityPage":
    case "sustainabilityQuizPage":
    case "transparencyActPage": {
      const match = storyData.default_full_slug?.match(/energydrink\/(.*)/i);
      if (!match) {
        throw new Error(`Unexpected path: ${storyData.default_full_slug}`);
      }

      return `/${localeString}/energydrink/${match[1]}`;
    }
    case "faq":
    case "faqCategory": {
      const match = storyData.default_full_slug?.match(
        /(questions|energydrink\/qa-taxonomy|energydrink\/questions)\/(.*)/i,
      );
      if (!match) {
        throw new Error(`Unexpected path: ${storyData.default_full_slug}`);
      }

      return `/${localeString}/energydrink/questions/${match[2]}`;
    }
    case "questionInterestGroup": {
      const match = storyData.default_full_slug?.match(
        /\/crh\/contact-taxonomy\/(.*)/i,
      );
      if (!match) {
        throw new Error(`Unexpected path: ${storyData.default_full_slug}`);
      }

      return `/${localeString}/support-hub/${match[1]}`;
    }
    // `crhPageSettings` is used for the support hub page homepage
    case "crhPageSettings": {
      return `/${localeString}/support-hub`;
    }
    // One `companyIndex` per market, the startpage of its `company` folder
    case "companyIndex": {
      return `/${localeString}/company`;
    }
    case "faqIndex": {
      return `/${localeString}/energydrink/questions`;
    }
    case "energydrinkIndex":
    case "energydrinkRuIndex": {
      return `/${localeString}/energydrink`;
    }
    case "momentOfNeed": {
      const match = storyData.default_full_slug?.match(
        /energydrink\/moments\/(.*)/i,
      );
      if (!match) {
        throw new Error(`Unexpected path: ${storyData.default_full_slug}`);
      }

      return `/${localeString}/energydrink/moment/${match[1]}`;
    }
    default: {
      throw new Error(`Unhandled content-type: ${storyData.content.component}`);
    }
  }
};
